import React from 'react';
import { useLocation } from 'react-router-dom';
import { useDict } from '../../contexts/LanguageContext';
import ROUTE_NAME from '../../routes/RouteName';
import LanguageToggle from '../languageToggle/views/LanguageToggle';
import SidebarLink from './SidebarLink';

const SidebarContent = (props) => {
    const dict = useDict();

    const location = useLocation();

    const { isSidebarShow, toggleSidebar } = props;

    const locationPath = location.pathname;

    if (locationPath !== '/firstTimeDashboard') {
        return (
            <div className="sidebar__content">
                <ul className="sidebar__block">
                    <SidebarLink
                        title={dict.investNow}
                        icon="Coins"
                        route={ROUTE_NAME.INVEST_NOW}
                        onClick={() => {
                            toggleSidebar();
                        }}
                    />
                    <SidebarLink
                        title={dict.performance}
                        icon="ChartLine"
                        route={ROUTE_NAME.PERFORMANCE}
                        onClick={() => {
                            toggleSidebar();
                        }}
                    />
                    <SidebarLink
                        title={dict.portfolio}
                        icon="FileInvoiceDollar"
                        route={ROUTE_NAME.PORTFOLIO}
                        onClick={() => {
                            toggleSidebar();
                        }}
                    />
                    <SidebarLink
                        title={dict.transaction}
                        icon="ExchangeAlt"
                        route={ROUTE_NAME.TRANSACTION}
                        onClick={() => {
                            toggleSidebar();
                        }}
                    />
                </ul>
                <ul className="sidebar__block">
                    <SidebarLink
                        title={dict.myProfile}
                        icon="User"
                        route={ROUTE_NAME.PROFILE}
                        onClick={() => {
                            toggleSidebar();
                        }}
                    />
                    <SidebarLink
                        title={dict.faqUserGuide}
                        icon="QuestionCircle"
                        route={ROUTE_NAME.FAQ_GENERAL_ENQUIRIES}
                        onClick={() => {
                            toggleSidebar();
                        }}
                    />
                </ul>
                <ul className="sidebar__block">
                    <LanguageToggle
                        selectClassName="sidebar-select"
                        formDivClassName="sidebar-language-toggle-form"
                    />

                    <SidebarLink
                        title={dict.logoutNav}
                        icon="Logout"
                        route={ROUTE_NAME.LOGOUT}
                    />
                </ul>
            </div>
        );
    }
    return (
        <div className="sidebar__content">
            <ul className="sidebar__block">
                <SidebarLink
                    title="Home"
                    icon="Home"
                    route={ROUTE_NAME.FIRST_TIME_DASHBOARD}
                    onClick={() => {
                        toggleSidebar();
                    }}
                />
            </ul>
            <ul className="sidebar__block">
                <SidebarLink
                    title="Log Out"
                    icon="Logout"
                    route={ROUTE_NAME.LOGOUT}
                />
            </ul>
        </div>
    );
};

export default SidebarContent;
